import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var WarningSystemIcon = function WarningSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12 0c.975 0 1.864.555 2.294 1.43l9.473 19.297A2.271 2.271 0 0121.728 24H2.272a2.271 2.271 0 01-2.04-3.272L9.707 1.429A2.556 2.556 0 0112 0zm0 1.5c-.403 0-.77.23-.948.59L1.58 21.39a.771.771 0 00.693 1.111h19.456a.771.771 0 00.693-1.112L12.948 2.091A1.056 1.056 0 0012 1.5zM12 18a1.125 1.125 0 110 2.25A1.125 1.125 0 0112 18zm0-10.5a.75.75 0 01.75.75v7.5a.75.75 0 11-1.5 0v-7.5A.75.75 0 0112 7.5z"
  })));
};

WarningSystemIcon.displayName = "WarningSystemIcon";
WarningSystemIcon.defaultProps = {
  size: 24
};
WarningSystemIcon.displayName = "WarningSystemIcon";
WarningSystemIcon.iconName = "Warning";
export default WarningSystemIcon;